module.exports = __webpack_public_path__ + "static/media/truwood.7592f72c.png";